// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"f3708fad","301":"a07418ad","719":"08781245","890":"19eea096","911":"c99d29cf"}[chunkId] + ".chunk.js";
};